export default __webpack_public_path__ + "static/media/delete_batteries_model.799d1329.csv";